import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@repo/common';

const SessionExpired = () => {
  const navigate = useNavigate();

  return (
    <div className='flex flex-col items-center justify-center text-center px-4 gap-2.5 flex-1'>
      <div className='flex flex-col items-center pb-[100px] gap-4'>
        <div className='typo-b16Strong tabletH:typo-b20Strong text-text-primary'>
          Your session has expired.
          <br /> Please log in again to continue.
        </div>
        <div>
          <BaseButton hideIcon size='l' onClick={() => navigate('/login')}>
            Go to Login
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;
